export const COUNT_OF_LIST_ITEMS = 5
